export default __webpack_public_path__ + "static/swipe_view-019cc70b80e4f9b3b29bff3f42b326f7.gif";